import styled from '@emotion/styled'

import { mediaQueryDown, mediaQueryUp } from '~/theme/utils/grid'

import { CarouselButton } from '~/shared/molecules/Carousel'

export const ButtonWrapper = styled.div`
  display: none;
  left: 1rem;
  bottom: 1rem;
  position: absolute;
  z-index: 1;

  ${mediaQueryUp('m')} {
    display: block;
  }
`

export const RestaurantPageCarouselWrapper = styled.div`
  grid-area: slider;
  position: relative;

  ${mediaQueryDown('m')} {
    width: 100vw;
    transform: translateX(-1rem);
  }
`

export const StyledCarouselButton = styled(CarouselButton)`
  width: 3rem;
  height: 3rem;
  img {
    height: 1rem;
    color: #6e6e6e;
  }
`
